module.exports = "<div class=\"modal\" [class.active]=\"stateActiveModal\"><div class=\"modal-layout\"></div><div class=\"window\"><header class=\"header\"><p class=\"title\">{{interfaceLocals['authMigrateProgressMessageTitle']}}</p></header><p class=\"question\">{{interfaceLocals['authMigrateProgressMessage']}}</p><div class=\"buttons\"><div class=\"button\" (click)=\"syncProgress()\">{{interfaceLocals['yes']}}</div><div class=\"button\" (click)=\"replaceProgress()\">{{interfaceLocals['no']}}</div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-help-addon-progress/modal-help-addon-progress.component.pug
// module id = 1045
// module chunks = 0